module.exports = __webpack_public_path__ + "files/96cf3c98aa1fb774e3d656610c915997.png";